import {IPluginComponentMap} from 'types/Plugins.types';
import BasicDetails from './steps/BasicDetails';
import TestsSelection from './steps/TestsSelection';

export const PluginComponentMap: IPluginComponentMap = {
  BasicDetails,
  TestsSelection,
};

export default PluginComponentMap;
